import { render, staticRenderFns } from "./video-detail.vue?vue&type=template&id=2c1d4c37&scoped=true"
import script from "./video-detail.vue?vue&type=script&lang=js"
export * from "./video-detail.vue?vue&type=script&lang=js"
import style0 from "./video-detail.vue?vue&type=style&index=0&id=2c1d4c37&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1d4c37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c1d4c37')) {
      api.createRecord('2c1d4c37', component.options)
    } else {
      api.reload('2c1d4c37', component.options)
    }
    module.hot.accept("./video-detail.vue?vue&type=template&id=2c1d4c37&scoped=true", function () {
      api.rerender('2c1d4c37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/detail/video-detail.vue"
export default component.exports